export default `query categoryList($id: String!) {
  categories(filters: { ids: { eq: $id } }) {
    items {
      name
      uid
      url_path
      include_in_menu
      level
    }
  }
}`